import React, { useState } from 'react';

export default function Crud() {
  const [empId, setEmpId] = useState('');
  const [empFirstName, setEmpFirstName] = useState('');
  const [empLastName, setEmpLastName] = useState('');
  const [salary, setSalary] = useState(null); // Changed to number
  const [deptId, setDeptId] = useState(null); // Changed to number
  const [deptName, setDeptName] = useState('');
  const [salaryId, setSalaryId] = useState(null); // Changed to number
  const [netPay, setNetPay] = useState(null); // Changed to number
  const [payrollId, setPayrollId] = useState(null); // Changed to number
  const [payrollDate, setPayrollDate] = useState('');

  async function handleSubmit() {
    if (
        empId &&
        empFirstName &&
        empLastName &&
        salary !== null &&
        deptId !== null &&
        deptName &&
        salaryId !== null &&
        payrollId !== null &&
        netPay !== null &&
        payrollDate
    ) {
      const data = {
        empId,
        empFirstName,
        empLastName,
        salary,
        deptId,
        deptName,
        salaryId,
        payrollId,
        netPay,
        payrollDate
      };

      const res = await fetch("https://payrole.onrender.com/insert", {
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'Content-Type': 'application/json' }
      });

      const likedpostcreatedtime = await res.json();

      alert(likedpostcreatedtime);
    } else {
      alert("Please fill in all fields before submitting.");
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#f4f4f4'
      }}
    >
      <div
        style={{
          background: 'white',
          padding: '20px',
          borderRadius: '10px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '20px',
          width: '80%',
          maxWidth: '400px'
        }}
      >
        <input
          type="number"
          value={empId}
          onChange={(e) => setEmpId(parseInt(e.target.value))}
          placeholder="Emp ID"
          style={{ padding: '10px' }}
        />
        <input
          type="text"
          value={empFirstName}
          onChange={(e) => setEmpFirstName(e.target.value)}
          placeholder="First Name"
          style={{ padding: '10px' }}
        />
        <input
          type="text"
          value={empLastName}
          onChange={(e) => setEmpLastName(e.target.value)}
          placeholder="Last Name"
          style={{ padding: '10px' }}
        />
        <input
          type="number"
          value={salary}
          onChange={(e) => setSalary(parseInt(e.target.value))}
          placeholder="Salary"
          style={{ padding: '10px' }}
        />
        <input
          type="number"
          value={deptId}
          onChange={(e) => setDeptId(parseInt(e.target.value))}
          placeholder="Dept ID"
          style={{ padding: '10px' }}
        />
        <input
          type="text"
          value={deptName}
          onChange={(e) => setDeptName(e.target.value)}
          placeholder="Dept Name"
          style={{ padding: '10px' }}
        />
        <input
          type="number"
          value={salaryId}
          onChange={(e) => setSalaryId(parseInt(e.target.value))}
          placeholder="Salary ID"
          style={{ padding: '10px' }}
        />
        <input
          type="number"
          value={payrollId}
          onChange={(e) => setPayrollId(parseInt(e.target.value))}
          placeholder="Payroll ID"
          style={{ padding: '10px' }}
        />
        <input
          type="number"
          value={netPay}
          onChange={(e) => setNetPay(parseFloat(e.target.value))}
          placeholder="Net Pay"
          style={{ padding: '10px' }}
        />
        <input
          type="text"
          value={payrollDate}
          onChange={(e) => setPayrollDate(e.target.value)}
          placeholder="Payroll Date"
          style={{ padding: '10px' }}
        />
        <button onClick={handleSubmit} style={{ padding: '10px' }}>
            INSERT DATA
        </button>
      </div>
    </div>
  );
}